import React from 'react';
import Link from 'next/link';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { generateAvatarFallback } from '@/utils/generateAvatarFallback';
import { ExportSquare } from 'iconsax-react';
import type { Platforms } from '@/types/search/searchTypes';

interface ExchangeChildItemsProps {
    childItem?: Platforms;
    index: number;
    action?: () => void;
}

const ExchangeCard: React.FC<ExchangeChildItemsProps> = ({ childItem, index, action }) => {
    const { faName, enName, logo, ctaURL, uri } = childItem || {};
    const avatarFallbackText = generateAvatarFallback(enName || '');
    return (
        <div
            className={`w-full snap-start md:basis-1/3 2xl:basis-1/4 relative flex pe-2.5 overflow-hidden border p-1.5 rounded-lg dark:border-white/20`}
        >
            <div className={`w-full flex justify-between text-white gap-3`}>
                <Link
                    key={index}
                    href={uri || '#'}
                    className={'flex items-center gap-2'}
                    onClick={action}
                >
                    <Avatar className={'flex justify-center items-center size-8 rounded-none'}>
                        <AvatarImage
                            className={'size-8 rounded-none object-contain'}
                            src={logo}
                            alt={enName}
                            title={enName}
                        />
                        <AvatarFallback className={'text-sm text-text/50'}>
                            {avatarFallbackText}
                        </AvatarFallback>
                    </Avatar>
                    <div className={'flex flex-col items-start dark:text-white text-primary'}>
                        <span className={'line-clamp-1'}>{faName}</span>
                        <span className={`text-xxs dark:text-white/80 text-primary/80`}>
                            ({enName})
                        </span>
                    </div>
                </Link>
                {childItem?.uri && (
                    <Link
                        onClick={action}
                        href={ctaURL || uri || '#'}
                        target={'_blank'}
                        rel={'nofollow'}
                        id={enName || ''}
                        className={`bg-progress px-3 py-1 text-white whitespace-nowrap rounded-lg text-sm transition-all hover:bg-transparent border border-progress hover:text-progress flex justify-center items-center gap-2  max-lg:text-xs stroke-white hover:stroke-progress`}
                    >
                        <ExportSquare variant={'TwoTone'} size={16} />
                        <span className={'z-[1]'}>افتتاح حساب</span>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default ExchangeCard;
